import styled, { css } from "styled-components";

import { Container } from "@ui/Atoms";

export const Root = styled(Container)`
  overflow-x: hidden;
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing_32};
  flex-direction: column;
`;

export const ScrollContainer = styled.ul<{ isCentered: boolean }>`
  padding: 0;
  flex-wrap: nowrap;
  list-style: none;
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing_24};
  margin: 0;

  ${props =>
    props.isCentered &&
    css`
      justify-content: center;
    `}

  ${props => props.theme.breakpoints.desktop} {
    gap: ${({ theme }) => theme.spacing.spacing_32};
  }
`;

export const SlideContainer = styled.li`
  width: fit-content;
  flex-shrink: 0;
  user-select: none;
  padding: 0;
`;

export const Scroll = styled.div<{ isVisible: boolean }>`
  background-color: ${props => props.theme.palette.grey200};
  height: 3px;
  pointer-events: none;
  overflow: hidden;
  display: ${props => (props.isVisible ? "block" : "none")};
`;

export const ScrollBar = styled.div<{
  elementsCount: number;
}>`
  background: ${props => props.theme.palette.blue500};
  width: ${props => 100 / props.elementsCount}%;
  height: 100%;
`;
